import React from "react";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default function BanerKons() {
  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          <div className='kons_baner'>
            <div className='kons_text1'>KONSULTACJE</div>
          </div>
        </div>
      </div>
    </>
  );
}
